import React from 'react';
import { Box } from 'rebass';
import { Input } from '@rebass/forms';
import { FiSearch } from 'react-icons/fi';

/**
 * Search input component.
 *
 * @param {Omit<React.InputHTMLAttributes<HTMLInputElement>>} props
 * @param {React.Ref<HTMLInputElement>} ref
 */
export default React.forwardRef(
    /**
     * @param {React.InputHTMLAttributes<HTMLInputElement>} props
     * @param {boolean} props.[displayHidden]
     * @param {string} props.[rootClassName]
     * @param {React.Ref<HTMLInputElement>} ref
     */
    ({ displayHidden, rootClassName, autoFocus, placeholder, style, ...rest }, ref) => (
        <Box
            className={rootClassName}
            style={{ position: 'relative', height: '32px', display: displayHidden ? 'none' : 'block' }}
        >
            {/* Logical inline properties: the magnifier sits at the leading edge
                and the input reserves room for it on that same side, so both must
                move to the right inside a `dir="rtl"` container (the search box in
                the Combobox popover). Under LTR these compute to the physical
                values they replaced, so nothing changes.

                `style` is pulled out of the props above and merged here rather
                than left in `...rest`, where this declaration would silently
                overwrite it. The padding stays last because it reserves the
                magnifier's gutter — a caller must not be able to collapse it. */}
            <Input
                ref={ref}
                {...rest}
                style={{ ...style, padding: '6px 0px', paddingInlineStart: '36px' }}
                type="text"
                className="input-darker"
                placeholder={placeholder && 'Search'}
            />
            <FiSearch
                className="text-primary"
                style={{
                    position: 'absolute',
                    insetInlineStart: '12px',
                    top: '8px',
                    strokeWidth: '1.5px',
                    fontSize: '16px'
                }}
            />
        </Box>
    )
);
